var ChatFeedback = /** @class */ (function () {
    function ChatFeedback() {
    }
    ChatFeedback.Disliked = -1;
    ChatFeedback.Neutral = 0;
    ChatFeedback.Liked = 1;
    return ChatFeedback;
}());
export { ChatFeedback };
